import { Dialog, DialogContent, DialogTitle, Switch } from "@mui/material";
import { Button } from "antd";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { customBaseUrl, httpPut } from "../../../../store/http";
import { hideLoader, showLoader } from "../../../../utils/loader";
import useMatStyles from "../style";

const EditPricing = ({ showModal, setShowModal, getPricing, pricingData }) => {
  const styles = useMatStyles();

  const [postData, setPostData] = useState({
    ...pricingData,
    effectiveFrom: pricingData.effectiveFrom ? new Date(pricingData.effectiveFrom).toISOString().slice(0, 16) : "",
    effectiveTo: pricingData.effectiveTo ? new Date(pricingData.effectiveTo).toISOString().slice(0, 16) : "",
  });

  useEffect(() => {
    setPostData({
        ...pricingData,
        effectiveFrom: pricingData.effectiveFrom ? new Date(pricingData.effectiveFrom).toISOString().slice(0, 16) : "",
        effectiveTo: pricingData.effectiveTo ? new Date(pricingData.effectiveTo).toISOString().slice(0, 16) : "",
    });
  }, [pricingData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPostData({
      ...postData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleMetadataChange = (e) => {
    const { name, value } = e.target;
    setPostData({
      ...postData,
      metadata: {
        ...postData.metadata,
        [name]: value,
      },
    });
  };

  const handleRuleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const newRules = [...postData.pricingRules];
    newRules[index] = {
      ...newRules[index],
      [name]: type === "checkbox" ? checked : value,
    };
    setPostData({ ...postData, pricingRules: newRules });
  };

  const addRule = () => {
    setPostData({
      ...postData,
      pricingRules: [
        ...postData.pricingRules,
        {
          actionType: "DISCOUNT_PERCENTAGE",
          actionValue: 0,
          conditionField: "amount",
          conditionOperator: "GREATER_THAN",
          conditionValue: 0,
          effectiveFrom: "",
          effectiveTo: "",
          isActive: true,
          priority: 1,
          ruleDescription: "",
          ruleName: "",
          ruleType: "VOLUME_BASED",
        },
      ],
    });
  };

  const removeRule = (index) => {
    const newRules = [...postData.pricingRules];
    newRules.splice(index, 1);
    setPostData({ ...postData, pricingRules: newRules });
  };

  const handleTierChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const newTiers = [...postData.pricingTiers];
    newTiers[index] = {
      ...newTiers[index],
      [name]: type === "checkbox" ? checked : value,
    };
    setPostData({ ...postData, pricingTiers: newTiers });
  };

  const addTier = () => {
    setPostData({
      ...postData,
      pricingTiers: [
        ...postData.pricingTiers,
        {
          discountPercentage: 0,
          fixedFee: 0,
          isActive: true,
          maxAmount: 0,
          maxQuantity: 0,
          minAmount: 0,
          minQuantity: 0,
          percentageRate: 0,
          priority: 1,
          tierDescription: "",
          tierName: "",
          unitPrice: 0,
        },
      ],
    });
  };

  const removeTier = (index) => {
    const newTiers = [...postData.pricingTiers];
    newTiers.splice(index, 1);
    setPostData({ ...postData, pricingTiers: newTiers });
  };


  const handleUpdate = async () => {
    showLoader();
    const url = `${customBaseUrl.integUrl}/api/v1/pricing/products/${postData.id}`;
    // Clean up empty rules and tiers before sending
    const payload = {
        ...postData,
        pricingRules: postData.pricingRules.filter(rule => rule.ruleName),
        pricingTiers: postData.pricingTiers.filter(tier => tier.tierName)
    }
    const response = await httpPut(url, payload);
    if (response.status === true) {
      setShowModal(false);
      Swal.fire("Done", response.message);
      getPricing();
      hideLoader();
    } else {
      setShowModal(false);
      Swal.fire("Error", response.message);
      hideLoader();
    }
  };

  return (
    <Dialog open={showModal} onClose={() => setShowModal(false)} fullWidth maxWidth="md">
      <DialogTitle>Edit Pricing</DialogTitle>
      <DialogContent>
        <div className="row">
          <div className="col-md-6">
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Pricing Name</div>
              <input name="pricingName" value={postData.pricingName} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Pricing Description</div>
              <input name="pricingDescription" value={postData.pricingDescription} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Product Code</div>
              <input name="productCode" value={postData.productCode} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Currency</div>
              <input name="currency" value={postData.currency} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
             <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Base Price</div>
              <input name="basePrice" type="number" value={postData.basePrice} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
          </div>
          <div className="col-md-6">
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Priority</div>
              <input name="priority" type="number" value={postData.priority} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
            <div className={styles.inputCont}>
                <div className={styles.inputLabel}>Pricing Model</div>
                <select name="pricingModel" value={postData.pricingModel} className={`${styles.inputInput} border`} onChange={handleChange}>
                    <option value="FIXED">FIXED</option>
                    <option value="TIERED">TIERED</option>
                    <option value="VOLUME">VOLUME</option>
                </select>
            </div>
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Effective From</div>
              <input name="effectiveFrom" type="datetime-local" value={postData.effectiveFrom} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Effective To</div>
              <input name="effectiveTo" type="datetime-local" value={postData.effectiveTo} className={`${styles.inputInput} border`} onChange={handleChange} />
            </div>
             <div className={styles.inputCont}>
                <div className={styles.inputLabel}>Is Active</div>
                <Switch name="isActive" checked={postData.isActive} onChange={handleChange} />
            </div>
          </div>
          <div className="col-md-12">
            <hr />
            <h5>Metadata</h5>
            <div className={styles.inputCont}>
                <div className={styles.inputLabel}>Feature</div>
                <input name="feature" value={postData.metadata?.feature} className={`${styles.inputInput} border`} onChange={handleMetadataChange} />
            </div>
          </div>

          <div className="col-md-12">
            <hr />
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h5>Pricing Rules</h5>
                <Button onClick={addRule} type="primary">Add Rule</Button>
            </div>
            {postData.pricingRules.map((rule, index) => (
                <div key={index} className="row" style={{border: "1px solid #eee", padding: "10px", margin: "10px 0"}}>
                    <div className="col-md-11">
                        {/* Rule fields */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Rule Name</div><input name="ruleName" value={rule.ruleName} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Rule Description</div><input name="ruleDescription" value={rule.ruleDescription} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Rule Type</div><input name="ruleType" value={rule.ruleType} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                            </div>
                            <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Condition Field</div><input name="conditionField" value={rule.conditionField} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Condition Operator</div><input name="conditionOperator" value={rule.conditionOperator} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Condition Value</div><input type="number" name="conditionValue" value={rule.conditionValue} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                            </div>
                             <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Action Type</div><input name="actionType" value={rule.actionType} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Action Value</div><input type="number" name="actionValue" value={rule.actionValue} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Priority</div><input type="number" name="priority" value={rule.priority} className={`${styles.inputInput} border`} onChange={(e) => handleRuleChange(index, e)} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1"><Button onClick={() => removeRule(index)} danger>Remove</Button></div>
                </div>
            ))}
          </div>

          <div className="col-md-12">
            <hr />
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h5>Pricing Tiers</h5>
                <Button onClick={addTier} type="primary">Add Tier</Button>
            </div>
            {postData.pricingTiers.map((tier, index) => (
                <div key={index} className="row" style={{border: "1px solid #eee", padding: "10px", margin: "10px 0"}}>
                    <div className="col-md-11">
                        {/* Tier fields */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Tier Name</div><input name="tierName" value={tier.tierName} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Tier Description</div><input name="tierDescription" value={tier.tierDescription} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Min Quantity</div><input type="number" name="minQuantity" value={tier.minQuantity} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Max Quantity</div><input type="number" name="maxQuantity" value={tier.maxQuantity} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                            </div>
                            <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Min Amount</div><input type="number" name="minAmount" value={tier.minAmount} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Max Amount</div><input type="number" name="maxAmount" value={tier.maxAmount} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Unit Price</div><input type="number" name="unitPrice" value={tier.unitPrice} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Fixed Fee</div><input type="number" name="fixedFee" value={tier.fixedFee} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                            </div>
                            <div className="col-md-4">
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Percentage Rate</div><input type="number" name="percentageRate" value={tier.percentageRate} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Discount Percentage</div><input type="number" name="discountPercentage" value={tier.discountPercentage} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Priority</div><input type="number" name="priority" value={tier.priority} className={`${styles.inputInput} border`} onChange={(e) => handleTierChange(index, e)} /></div>
                                <div className={styles.inputCont}><div className={styles.inputLabel}>Is Active</div><Switch name="isActive" checked={tier.isActive} onChange={(e) => handleTierChange(index, e)} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1"><Button onClick={() => removeTier(index)} danger>Remove</Button></div>
                </div>
            ))}
          </div>

          <div className="col-md-12">
            <div
              style={{
                marginTop: "20px",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
              className={styles.inputCont}
            >
              <Button onClick={handleUpdate} className={styles.filledButton} type="primary" size="large">
                Update Pricing
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditPricing;
